/* eslint-disable max-len */
import axios from 'axios';
import i18n from 'i18next';

import { handleAxiosError } from 'core/notifications';

import { handleResetTree } from '@/nestedRows';

export default async ({
  destination,
  params,
  rows,
  source,
  currentTreeContentKey,
  queryClient,
}) => {
  const itemId = rows.items[destination.parentId].children[destination.index];
  const previousListItemId =
    rows.items[destination.parentId].children[destination.index - 1] || null;
  const parentId = Number(params.id) || null;

  const data = {
    parent_list_item_id: parentId,
    previous_list_item_id: previousListItemId,
  };

  const url = `/api/admin/videos/${itemId}/move`;

  try {
    await axios.put(url, { data });
    queryClient.setQueryData(currentTreeContentKey, rows);
  } catch (error) {
    if (error.response?.status === 403) {
      handleResetTree({
        source,
        rows,
        destination,
        cacheKey: currentTreeContentKey,
        key: i18n.t('reorder-error'),
        queryClient,
      });
    } else {
      handleAxiosError(error);
    }
  }
};
